import { isFunc, minDate } from "../utils";
import Observer from "./Observer";
import Proxy from "./Proxy";

const modelStores: { [name: string]: (CachedModel) } = {};
const stores: { [name: string]: (CachedStore) } = {};

type LoadFn<T> = (() => Promise<T>);
function applyLoadFn<T>(loadFn?: LoadFn<T> | string) {
    if (!loadFn) {
        return undefined;
    }

    if (isFunc(loadFn)) {
        return loadFn as LoadFn<T>;
    }

    let cmd = loadFn as string;
    return () => Proxy.get(cmd).then(x => x.result?.Data || x.result);
}


export class CachedModel<T = any> {
    private name: string;
    private timeout: number;
    private loadFn?: LoadFn<T>

    private observer: Observer;

    private currentLoad?: Promise<T>;
    private ts: Date

    data?: T

    constructor(name: string, loadFn?: LoadFn<T> | string, timeout: number = 15) {
        this.name = name;
        this.loadFn = applyLoadFn(loadFn);
        this.timeout = timeout;
        this.ts = minDate;

        this.observer = new Observer();
    }

    static ConfigureModel<T>(name: string, loadFn?: LoadFn<T> | string, timeout: number = 15) {
        if (modelStores[name]) {
            modelStores[name].name = name;
            modelStores[name].timeout = timeout;
            modelStores[name].loadFn = applyLoadFn(loadFn);
        } else {
            modelStores[name] = new CachedModel<T>(name, loadFn, timeout);
        }

        return modelStores[name] as CachedModel<T>;
    }

    static GetModel<T>(name: string) {
        return modelStores[name] as CachedModel<T>;
    }

    // TODO: ������� ���������� �������� ��� �������� ���������
    clear() {
        this.ts = minDate;
    }

    load(loadFn?: LoadFn<T>): (Promise<T> | undefined) {
        if (!loadFn) {
            loadFn = this.loadFn;
        }

        if (this.ts > new Date()) {
            return Promise.resolve(this.data!);
        }

        if (this.currentLoad) {
            return this.currentLoad;
        }

        if (loadFn) {
            return this.currentLoad = loadFn().then(x => {
                delete this.currentLoad;

                this.data = x;
                this.ts = new Date();
                this.ts = new Date(this.ts.getFullYear(), this.ts.getMonth(), this.ts.getDate(), this.ts.getHours(), this.ts.getMinutes(), this.ts.getSeconds() + this.timeout);

                this.observer.fire('load', [x]);

                return x;
            })
        }
    }

    onLoad(fn: (data: T) => any) {
        this.load();
        return this.observer.listen('load', fn);
    }

    addSave(cmd: string) {
        return Proxy.on(cmd, e => {
            this.ts = new Date();/**
            const entity = e.body as T & IEntity;
            const id = e.response.result as number;
            debugger;
            if (entity && id) {
                entity.Id = id;

                const data = this.data || (this.data = []);

                const index = data.findIndex(x => (x as IEntity).Id == id)!;
                if (index >= 0) {
                    data[index] = entity;
                } else {
                    data.push(entity);
                }
            }/**/
        });
    }

    addDelete(cmd: string) {
        return Proxy.on(cmd, () => this.ts = new Date());
    }
}

export default class CachedStore<T = any> extends CachedModel<T[]> {
    static Configure<T>(name: string, loadFn?: LoadFn<T[]> | string, timeout: number = 15) {
        if (stores[name]) {
            stores[name].name = name;
            stores[name].timeout = timeout;
            stores[name].loadFn = applyLoadFn(loadFn);
        } else {
            stores[name] = new CachedStore<T>(name, loadFn, timeout);
        }

        return stores[name] as CachedStore<T>;
    }

    static Get<T>(name: string) {
        return stores[name] as CachedStore<T>;
    }
}